import React from 'react';


const Creator = (props)  => {
       return ( 
           <div className="creator">
        <p>Made by <a href="https://www.chidwi.com">{props.name}</a></p>
            </div>
    );
}
export default Creator;


// WEBPACK FOOTER //
// ./src/components/Creator.js